const WECHAT_CONTEXT_STORAGE_KEY = "wechat_auth_context";
const WECHAT_LOGIN_EMAIL_STORAGE_KEY = "wechat_login_email";
const WECHAT_CONTEXT_TTL_MS = 15 * 60 * 1000;
const WECHAT_CONTEXT_PARAM_NAMES = [
  "isReg",
  "UID",
  "providerUid",
  "regToken",
  "successRedirectUrl",
  "redirectUrl",
];

const canUseSessionStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

export const getWeChatQueryParameter = (
  name,
  search = typeof window !== "undefined" ? window.location.search : "",
) => {
  if (!search) return "";

  return new URLSearchParams(search).get(name) || "";
};

const sanitizeContext = (context = {}) =>
  WECHAT_CONTEXT_PARAM_NAMES.reduce((nextContext, paramName) => {
    if (context[paramName]) {
      nextContext[paramName] = context[paramName];
    }

    return nextContext;
  }, {});

const readStoredContext = () => {
  if (!canUseSessionStorage()) return {};

  try {
    const storedValue = window.sessionStorage.getItem(
      WECHAT_CONTEXT_STORAGE_KEY,
    );

    if (!storedValue) return {};

    const parsedValue = JSON.parse(storedValue);
    const isExpired =
      !parsedValue?.createdAt ||
      Date.now() - parsedValue.createdAt > WECHAT_CONTEXT_TTL_MS;

    if (isExpired) {
      window.sessionStorage.removeItem(WECHAT_CONTEXT_STORAGE_KEY);
      return {};
    }

    return sanitizeContext(parsedValue.values);
  } catch (error) {
    window.sessionStorage.removeItem(WECHAT_CONTEXT_STORAGE_KEY);
    return {};
  }
};

const writeStoredContext = (context) => {
  if (!canUseSessionStorage()) return;

  window.sessionStorage.setItem(
    WECHAT_CONTEXT_STORAGE_KEY,
    JSON.stringify({
      values: context,
      createdAt: Date.now(),
    }),
  );
};

const getContextFromSearch = (search) =>
  WECHAT_CONTEXT_PARAM_NAMES.reduce((nextContext, paramName) => {
    const paramValue = getWeChatQueryParameter(paramName, search);

    if (paramValue) {
      nextContext[paramName] = paramValue;
    }

    return nextContext;
  }, {});

export const captureWeChatContextFromSearch = (
  search = typeof window !== "undefined" ? window.location.search : "",
) => {
  const contextFromSearch = getContextFromSearch(search);

  if (Object.keys(contextFromSearch).length > 0) {
    writeStoredContext(contextFromSearch);
    return contextFromSearch;
  }

  return readStoredContext();
};

export const getWeChatContext = () => readStoredContext();

export const setWeChatLoginEmail = (email) => {
  if (!canUseSessionStorage()) return;

  window.sessionStorage.setItem(WECHAT_LOGIN_EMAIL_STORAGE_KEY, email);
};

export const getWeChatLoginEmail = () => {
  if (!canUseSessionStorage()) return "";

  return window.sessionStorage.getItem(WECHAT_LOGIN_EMAIL_STORAGE_KEY) || "";
};

export const clearWeChatContext = () => {
  if (!canUseSessionStorage()) return;

  window.sessionStorage.removeItem(WECHAT_CONTEXT_STORAGE_KEY);
  window.sessionStorage.removeItem(WECHAT_LOGIN_EMAIL_STORAGE_KEY);
};
